<template>
  <div class="data-manage data-detail pb-3 mb-3 row">
    <div class="detail-content">
      <div class="clearfix">
        <nav class="float-left">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <a class="text-dark" @click="goBack">
                <strong>
                  <i class="fa fa-chevron-left mr5"></i>
                  {{ $t("back") }}
                </strong>
              </a>
            </li>
            <li class="breadcrumb-item text-grey" aria-current="page">
              {{ $t("nav.MRI_analysis") }}
            </li>
            <li class="breadcrumb-item text-dark" aria-current="page">
              {{ $t("project.view_report") }}
            </li>
          </ol>
        </nav>
        <div class="text-right float-right mt-3 mr-3">
          <router-link
            :to="{
              name: 'reportCreate',
              query: { subject_id: subjectid, task_id: task_id },
            }"
            class="btn btn-sm btn-danger"
          >
            <i class="fa fa-plus-square"></i>
            {{ $t("project.c_report") }}</router-link
          >
        </div>
      </div>
      <listComponent :subject_id="subjectid" :task_id="task_id" />
    </div>
    <div class="subject_sidebar">
      <div class="info-side mt-3 p-0 m-0">
        <div class="side-header">
          <strong class="mr5">{{ $t("_data.patient_info") }}</strong>
          <span v-if="isMember" class="edit-btn cursor" @click.stop="modifyInfo"
            >[{{ $t("_data.modify") }}]</span
          >
        </div>
        <div class="side-content">
          <div class="info-item clearfix">
            <span class="fl">{{ $t("_data.p_name") }}:</span>
            <span class="fr">{{ edit_subject.subject_name }}</span>
          </div>
          <div class="info-item clearfix">
            <span class="fl">{{ $t("analyse.body_part") }}:</span>
            <span
              class="fr ml5 modality-span"
              v-for="(part, index) in edit_subject.body_part_examined"
              :key="index"
              >{{ part }}</span
            >
          </div>
          <div class="info-item clearfix">
            <span class="fl">{{ $t("project.modality") }}:</span>
            <span
              class="fr ml5 modality-span"
              v-for="(modal, index) in edit_subject.modality"
              :key="index"
              >{{ modal }}</span
            >
          </div>
          <div class="info-item clearfix">
            <span class="fl">{{ $t("age") }}:</span>
            <span class="fr">
              {{ edit_subject.subject_age }}
              <dfn v-if="edit_subject.subject_age">{{
                $t($helper.formatAgeUnit(edit_subject.subject_age_unit))
              }}</dfn>
            </span>
          </div>
          <div class="info-item clearfix">
            <span class="fl">{{ $t("gender") }}:</span>
            <span class="fr">{{
              $t(getGenderKey(edit_subject.subject_gender))
            }}</span>
          </div>
          <div class="info-item clearfix">
            <span class="fl">{{ $t("project.series") }}:</span>
            <span
              class="fr ml5 series-span"
              v-for="(serial, index) in edit_subject.series"
              :key="index"
              >{{ serial }}</span
            >
          </div>
          <div class="info-item clearfix">
            <span class="fl">{{ $t("_data.tags") }}:</span>
            <span
              v-if="isMember"
              class="fl ml5 edit-btn cursor"
              @click.stop="openTagModel"
              >[{{ $t("_data.edit_tag") }}]</span
            >
            <span
              class="fr ml5 tags-span"
              v-for="(tag, index) in edit_subject.tags"
              :key="index"
              >{{ tag.name }}</span
            >
          </div>
          <div class="info-item clearfix">
            <span>{{ $t("_data.diagnostic") }}:</span>
            <div class="diagnostic" v-if="edit_subject.subject_explain">
              {{ edit_subject.subject_explain }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dialog-wrapper" v-if="dialogVisible">
      <div class="dialog-content">
        <div class="dialog-header">
          <span class="dialog-title">{{ $t("_data.tips") }}</span>
          <button
            type="button"
            class="dialog-headerbtn"
            @click="dialogVisible = false"
          >
            <i class="dialog-close el-icon el-icon-close"></i>
          </button>
        </div>
        <div class="dialog-body">
          <span>{{ $t("_data.packing") }}</span>
        </div>
      </div>
    </div>
    <edit-subject
      :patientInfo="patientInfo"
      :showPopover="showEditPopover"
      @closeEditPopover="showEditPopover = false"
      @submitSubject="submitSubject"
    ></edit-subject>
    <set-tags
      :tagsList="tagsList"
      :selectedTags="selectedTags"
      :showPopover="showTagsPopover"
      @closeTagsPopover="showTagsPopover = false"
      @addTag="addTag"
      @submitTags="submitTags"
    ></set-tags>
  </div>
</template>
    
    <script>
import { mapState } from "vuex";
import { eventHub } from "@/eventHub.js";
import { dataRequest, tagsRequest } from "../../api/api";
// import pagination from "../../components/pager";
// import { paginationMixin } from "../../utils/mixin";
import { Loading } from "element-ui";
import editSubject from "../../components/subject/editSubject";
import setTags from "../../components/subject/setTags";

import listComponent from "./listComponent";

export default {
  components: {
    editSubject,
    setTags,
    listComponent,
  },
  data() {
    return {
      subjectid: this.$route.query.subject_id,
      task_id: this.$route.query.task_id,
      rowId: "",
      user: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user"))
        : {},
      user_rights: localStorage.getItem("user_rights")
        ? JSON.parse(localStorage.getItem("user_rights"))
        : {},
      dialogVisible: false,
      edit_subject: {},
      dataUser: {},
      dataUserID: null,
      patientInfo: {},
      tagsList: [],
      selectedTags: [],
      showEditPopover: false,
      showTagsPopover: false,
      formData: [],
      token: localStorage.token,
      isMember: false, //是否为数据所有者或共享成员
      project_id: null,
      centerDialogVisible: false,
      isClickclose: false,
      isLockScroll: false,
      query_data: {}, //getSubjectData
    };
  },

  computed: {
    ...mapState({
      lang: (state) => state.language,
      url_backendapi: (state) => state.url_backendapi, //:28801
      url_adaptorapi: (state) => state.url_adaptorapi, //:28000
    }),
  },
  filters: {},
  watch: {
    dataUserID() {
      this.isDataMember();
    },
  },
  methods: {
    goBack() {
      //console.log(this.$route.query);
      let offset = this.$route.query.from_offset || 1;
      if (this.$route.query.from) {
        let from = this.$route.query.from;
        switch (from) {
          case "datalist":
            this.$router.push({
              path: "/data-manage/list",
              query: {
                offset: offset,
              },
            });
            break;

          case "analyselist":
            this.$router.push({
              path: "/mri-analysis",
              query: {
                offset: offset,
              },
            });
            break;

          default:
            this.$router.back();
            break;
        }
      } else {
        this.$router.back();
      }
    },
    isDataMember() {
      const login_userid = this.user.id;
      const project_members = this.project_shared_userids;
      this.isMember =
        login_userid == this.dataUserID ||
        (project_members &&
          project_members.length &&
          project_members.indexOf(login_userid) >= 0);
    },

    async getSubjectData() {
      //console.log("getSubjectData");
      let query_data = {};
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {
        request: "detail",
        userid: this.$store.state.userid,
        subjectid: this.subjectid,
        data_type: "1",
      };
      this.query_data = {};
      try {
        let res = await dataRequest(params);
        if (res.status === 200) {
          // this.dataList =
          //   res.data && res.data.head.length > 0
          //     ? this.addKeyToFilesItem(res.data.head)
          //     : [];
          //this.dataList = res.data && res.data.head ? res.data.head : [];
          this.edit_subject = res.data;
          this.dataUser = res.data.user || {};
          this.dataUserID = res.data.user_id;
          //this.project_id = res.data.project_id;
          //this.project_shared_userids = res.data.project_shared_userids;
          query_data = res;

          this.query_data = query_data;
        }
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
    showMenu(rowData) {
      this.rowId = rowData.id;
    },
    hideMenu() {
      this.rowId = "";
    },
    handleCommand(command) {
      console.log("h c", command);
    },
    handleDownload(file, type) {
      return {
        file: file,
        type: type,
      };
    },
    async modalDownload(file, type) {
      const me = this;
      //this.dialogVisible = true;

      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.rowId = "";
      const { id } = this.user;
      let params = {
        userid: id,
        fileid: file.id,
        projectid: file.project_id || 0,
        request: "download_file_" + type,
      };
      try {
        let res = await downloadPackage(params);
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          eventHub.$emit("getProcessList");
          //换弹窗，链接打开下载url;
          // me.downloadurl = res.downloadurl;
          // me.centerDialogVisible = true;
        } else {
          this.$helper.errNotify(res.message);
        }
        //this.dialogVisible = false;
        loadingInstance.close();
      } catch (error) {
        //this.dialogVisible = false;
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
    //打开修改受试者信息弹窗
    modifyInfo() {
      this.patientInfo = {
        userid: this.edit_subject.user_id,
        subject_id: this.edit_subject.id,
        subject_gender: this.edit_subject.subject_gender,
        subject_age: this.edit_subject.subject_age,
        subject_age_unit: this.edit_subject.subject_age_unit,
        subject_name: this.edit_subject.subject_name,
        subject_explain: this.edit_subject.subject_explain,
        projectid: this.edit_subject.project_id || 0,
      };
      this.showEditPopover = true;
      this.rowId = "";
    },
    //提交新的受试者信息
    async submitSubject(patientInfo) {
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      let params = {
        request: "edit",
        ...patientInfo,
      };
      try {
        let res = await dataRequest(params);
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          this.getSubjectData();
          this.showEditPopover = false;
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
    openTagModel() {
      let _self = this;
      this.selectedTags = this.edit_subject.tags.map(function (item) {
        return item.id;
      });
      this.getTagList(function () {
        _self.showTagsPopover = true;
      });
    },
    async getTagList(callBack) {
      let params = {
        request: "list",
        userid: this.dataUserID, //this.$store.state.userid,
      };
      try {
        let res = await tagsRequest(params);
        if (res.status === 200) {
          this.tagsList = res.data.length > 0 ? res.data : [];
        }
        callBack && callBack();
      } catch (error) {
        this.$helper.errNotify(error.message);
      }
    },
    //添加新的标签
    async addTag(tagName) {
      //let _self = this;

      if (!tagName) {
        this.$helper.warningMessage(this.$t("tags.tag_message_require"));
        return false;
      }

      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      let params = {
        request: "insert",
        userid: this.dataUserID, //this.$store.state.userid,
        name: tagName,
      };
      try {
        let res = await tagsRequest(params);
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          this.getTagList();
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
    //给受试者设置标签
    async submitTags(tags) {
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      let params = {
        request: "tagsubject",
        userid: this.dataUserID, // this.$store.state.userid,
        subject_id: this.edit_subject.id,
        tagids: tags,
        tagname: "",
      };
      try {
        let res = await tagsRequest(params);
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          this.getSubjectData();
          this.showTagsPopover = false;
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
    getGenderKey(gender) {
      return gender === "1" ? "female" : gender === "0" ? "male" : "";
    },
    viewTaskList() {
      this.$router.push({
        name: "mriAnalysis",
        query: { subject_id: this.subjectid, app_id: this.search_app_id },
      });
    },
  },
  mounted() {
    this.getSubjectData();
    //this.getBodyPartsList();
    document.body.addEventListener("click", this.hideMenu, false);
  },
  beforeDestroy() {
    document.body.removeEventListener("click", this.hideMenu);
  },
};
</script>
    
    <style lang="less" scoped>
.availableapps {
  margin-bottom: 15px;
}
.table {
  border-bottom: 1px solid #dee2e6;
}
.data-manage {
  position: relative;
  padding-right: 320px;
  .detail-content {
    width: 100%;
  }
  .subject_sidebar {
    position: absolute;
    top: -15px;
    bottom: 0;
    right: 0;
    z-index: 100;
    padding: 0 10px;
    border-left: 1px solid #eee;
    background: #fff;
  }
  .data-content {
    margin-bottom: 20px;
    background: #fff;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .table-info {
    background: #eeeeee;
  }
  .el-checkbox {
    margin-bottom: 0;
    color: #fff;
  }
  .el-table .cell {
    overflow: visible;
    text-align: center;
  }
  .el-table {
    overflow: visible;
    .col-btn {
      display: inline-block;
      margin-top: 5px;
      padding: 0 5px;
      border-radius: 5px;
      height: 24px;
      line-height: 24px;
      color: #fff;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 100%;
      min-width: 80px;
      max-width: 140px;
      text-align: center;
      &.warn-btn {
        background: #ffc106;
      }
      &.success-btn {
        background: #26a745;
      }
      &.view-dicom {
        background: #ffa25b;
      }
    }
  }
  &.data-detail .el-table td {
    padding: 7px 0 12px;
  }
  .el-table__body-wrapper {
    overflow: visible !important;
  }
  .operate-wrapper {
    padding: 10px;
  }

  .dialog-wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2003;
    overflow: auto;
    margin: 0;
    background: rgba(0, 0, 0, 0.6);
    .dialog-content {
      position: relative;
      margin: 15vh auto;
      border-radius: 3px;
      width: 600px;
      background: #fff;
    }
    .dialog-header {
      padding: 20px 10px;
      border-bottom: 1px solid #dee2e6;
    }
    .dialog-title {
      line-height: 24px;
      font-size: 18px;
      color: #303133;
    }
    .dialog-headerbtn {
      position: absolute;
      top: 20px;
      right: 20px;
      padding: 0;
      background: 0 0;
      border: none;
      outline: 0;
      cursor: pointer;
      font-size: 16px;
    }
    .dialog-body {
      padding: 30px 0;
      text-align: center;
    }
  }
  .info-side {
    width: 290px;
    position: sticky;
    top: 0;
    margin-bottom: 20px;
    .side-header {
      margin-bottom: 10px;
    }
    .edit-btn {
      color: #067afd;
    }
    .side-content {
      border-radius: 3px;
      background: #fff;
      box-shadow: 1px 1px 1px 2px #f2f2f2;
    }
    .info-item {
      padding: 7px 10px;
      border-bottom: 1px solid #dfdfdf;
      color: #6c757d;
      &:last-child {
        border-bottom: none;
      }
    }
    .diagnostic {
      padding: 5px 10px;
      max-height: 100px;
      border: 1px solid #bfbfc1;
      overflow-y: auto;
    }
  }
  .el-dialog__body {
    text-align: center;
  }
}
</style>
    